module.exports = __webpack_public_path__ + "static/media/icon_36.66c52bb4.svg";